const month =[
  {
    _id: "0",
    name: "กรุณาเลือก"
  },
    {
        _id: "01",
        name: "มกราคม"
      },
      {
        _id: "02",
        name: "กุมภาพันธ์"
      },
      {
        _id: "03",
        name: "มีนาคม"
      },
      {
        _id: "04",
        name: "เมษายน"
      },
      {
        _id: "05",
        name: "พฤษภาคม"
      },
      {
        _id: "06",
        name: "มิถุนายน"
      },
      {
        _id: "07",
        name: "กรกฎาคม"
      },
      {
        _id: "08",
        name: "สิงหาคม"
      },
      {
        _id: "09",
        name: "กันยายน"
      },
      {
        _id: "10",
        name: "ตุลาคม"
      },
      {
        _id: "11",
        name: "พฤศจิกายน"
      },
      {
        _id: "12",
        name: "ธันวาคม"
      },
]
export function getMonth() {
    return month;
  }